import { css } from 'styled-components'

import { helpers } from './theme'

export default css`
	h1,
	h2,
	h3,
	h4,
	h5 {
		color: ${helpers.color.textHeader};
		margin-top: 32px;
		margin-bottom: 10px;
		scroll-margin-top: 32px;
	}

	h1 {
		font: ${helpers.font.size.h1};
		margin: 32px 0 16px;
	}

	h2 {
		font: ${helpers.font.size.h2};
		margin-top: 48px;
		scroll-margin-top: 48px;
	}

	h3 {
		font: ${helpers.font.size.h3};
		margin-top: 40px;
		scroll-margin-top: 40px;
	}

	h4 {
		font: ${helpers.font.size.h4};
		color: ${helpers.color.textHeader};
	}

	h5 {
		font: ${helpers.font.size.h5};
		color: ${helpers.color.textHeader};
	}

	p {
		margin: 0 0 10px;
	}

	small {
		font-size: ${helpers.font.size.small};
	}

	ul {
		padding: 0 0 0 24px;
		margin: 18px 0;

		ul {
			margin: 0 0 16px;
		}
	}

	li {
		margin: 6px 0;
	}

	hr {
		margin: 42px 0;
		border-top: 1px solid ${helpers.color.border};
		height: 0;
	}

	code {
		font-family: ${helpers.font.family.code};
		font-size: 93.333%;
		color: ${helpers.color.code};
		background-color: ${helpers.color.codeTranslucent};
		border-radius: 4px;
		padding: 1px 4px;
		margin: -1px 0;

		a & {
			background-color: ${helpers.color.linkBackgroundActive};
			color: ${helpers.color.link};
			text-decoration: underline;
		}
	}
`
